import { useSearchParams } from 'react-router-dom';
import { useGetDrishtiAspectsMutation } from '@/store/api/drishtiApi';
import { useEffect } from 'react';
import { safeRender } from '@/utils/helper.utils';

export default function DrishtiAspectsPage() {
  const [params] = useSearchParams();
  const userId = params.get('userId');

  const [GetDrishtiAspects, { data, isLoading, isError }] = useGetDrishtiAspectsMutation();

  useEffect(() => {
    if (userId) {
      GetDrishtiAspects(userId);
    }
  }, [userId, GetDrishtiAspects]);

  if (isError) {
    return <p className="p-6 text-center text-red-500 text-lg">Failed to load Drishti data</p>;
  }

  const aspects = data?.dhristiAspects?.aspects ?? [];

  return (
    <div className="w-full max-w-full overflow-x-hidden">
      <h3 className="text-3xl font-bold font-spectral mb-6 text-center text-[#2A185C]">
        DRISHTI / ASPECTS OF PLANETS
      </h3>

      <div className="overflow-x-auto w-full rounded-md shadow-sm border border-[#06186C]">
        <table className="w-full min-w-[800px] border-collapse border-hidden font-18 whitespace-nowrap">
          <thead className="bg-[#031B5B] text-white font-serif uppercase font-semibold tracking-wide">
            <tr className="text-center align-middle">
              <th className="border border-[#031B5B] border-r-white/30 px-4 py-4 min-w-[153px] leading-tight flex-col justify-center">
                Planet / Asc
              </th>
              <th className="border border-[#031B5B] border-r-white/30 px-4 py-4 min-w-[185px] leading-tight">
                Sign
              </th>
              <th className="border border-[#031B5B] border-r-white/30 px-4 py-4 leading-tight">
                Aspect(s)
              </th>
              <th className="border border-[#031B5B] border-r-white/30 px-4 py-4 min-w-[190px] leading-tight">
                Sign(s) Aspected
              </th>
              <th className="border border-[#031B5B] border-r-white/30 px-4 py-4 leading-tight">
                Houses <br /> Aspected <br /> From Lagna
              </th>
              <th className="border border-[#031B5B] border-r-white/30 px-4 py-4 min-w-[280px] leading-tight">
                Planet/Sign Aspected from Lagna
              </th>
              <th className="border border-[#031B5B] border-r-white/30 px-4 py-4 leading-tight">
                Houses Aspected <br /> From Rashi/Moon
              </th>
              <th className="border border-[#031B5B] px-4 py-4 min-w-[280px] leading-tight">
                Planet/Sign Aspected From Moon/Rashi
              </th>
            </tr>
          </thead>

          <tbody className="text-gray-900 font-normal font-sans">
            {aspects.map((item: any, i: number) => {
              const split = (val: any) =>
                String(val || '')
                  .split(',')
                  .map((v) => v.trim())
                  .filter(Boolean);

              return (
                <tr
                  key={i}
                  className={`border-b border-[#031B5B]/30 hover:opacity-95 transition-opacity ${
                    i % 2 === 0 ? 'bg-white' : 'bg-[#61C2FF]'
                  }`}
                >
                  <td className="border-r border-[#031B5B]/30 px-4 py-3 text-left">
                    {safeRender(item.planets)}
                  </td>
                  <td className="border-r border-[#031B5B]/30 px-4 py-3 text-left">
                    {safeRender(item.signs)}
                  </td>

                  <td className="border-r border-[#031B5B]/30 px-4 py-3 text-center">
                    {split(item.aspectsOfSign).length
                      ? split(item.aspectsOfSign).map((v, idx) => (
                          <div key={idx} className="py-0.5">
                            {safeRender(v)}
                          </div>
                        ))
                      : '-'}
                  </td>

                  <td className="border-r border-[#031B5B]/30 px-4 py-3 text-left">
                    {split(item.signAspected).length
                      ? split(item.signAspected).map((v, idx) => (
                          <div key={idx} className="py-0.5">
                            {safeRender(v)}
                          </div>
                        ))
                      : '-'}
                  </td>

                  <td className="border-r border-[#031B5B]/30 px-4 py-3 text-center">
                    {split(item.houseAscpectedForLagna).length
                      ? split(item.houseAscpectedForLagna).map((v, idx) => (
                          <div key={idx} className="py-0.5">
                            {safeRender(v)}
                          </div>
                        ))
                      : '-'}
                  </td>

                  <td className="border-r border-[#031B5B]/30 px-4 py-3 text-center">
                    {split(item.anyPlanetOrSignAspected).length
                      ? split(item.anyPlanetOrSignAspected).map((v, idx) => (
                          <div key={idx} className="py-0.5">
                            {safeRender(v)}
                          </div>
                        ))
                      : '-'}
                  </td>

                  <td className="border-r border-[#031B5B]/30 px-4 py-3 text-center">
                    {split(item.houseAscpectedForRashi).length
                      ? split(item.houseAscpectedForRashi).map((v, idx) => (
                          <div key={idx} className="py-0.5">
                            {safeRender(v)}
                          </div>
                        ))
                      : '-'}
                  </td>

                  <td className="px-4 py-3 text-center">
                    {split(item.anyPlanetOrSignAspected).length
                      ? split(item.anyPlanetOrSignAspected).map((v, idx) => (
                          <div key={idx} className="py-0.5">
                            {safeRender(v)}
                          </div>
                        ))
                      : '-'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
